<template>
  <div>
    <FormStepInputs
      :step="{
        stepName: name,
        formInputs: content,
      }"
    >
      <template #memberBenefitsPanelTitle>
        <div class="flex gap-y-1">
          <PanelTitle v-bind="getFormInput(props.content, 'memberBenefitsPanelTitle')"></PanelTitle>
        </div>
      </template>
      <template #actionBar>
        <ActionBar
          v-if="actionBarButtons"
          v-bind="actionBarButtons"
          :outerClass="actionBarContent.outerClass"
          :innerClass="actionBarContent.innerClass"
          :handleLinkClickEvent="true"
          @btnClick="(linkName) => onClick_ActionBarButton(linkName)"
        ></ActionBar>
      </template>
    </FormStepInputs>
  </div>
</template>
<script setup lang="ts">
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import { computed, ref } from 'vue';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import { getFormInput } from '@/utils/form-input-helper';
import ActionBar from '@/components/ActionBar/ActionBar.vue';
import { useAccountStore } from '@/store';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();

const accountStore = useAccountStore();
const actionBarContent = getFormInput(props.content, 'actionBar');

const membershipLoyaltyLevel = ref<string>(accountStore.identityDetails?.membershipLoyalty ?? '');

const actionBarButtons = computed(() => {
  actionBarContent.fields[0].link!.value!.text = `${membershipLoyaltyLevel.value} benefits`;
  return actionBarContent;
});

const onClick_ActionBarButton = async (linkItem: any) => {
  const memberBenefits = document.getElementById('memberBenefits');
  if (memberBenefits) {
    memberBenefits.scrollIntoView({ behavior: 'smooth' });
  }
};
</script>
